import {reportResize} from './resizeReporter'
import {watchBodyMutations} from './mutationWatcher'
import {reportClick} from './clickReporter';
import {postToParent} from './messageHandlers'


window.postToParent = postToParent
window.reportResize = reportResize

let lastWindowWidth = window.innerWidth
let resizeTimeoutId: ReturnType<typeof setTimeout> | undefined

function queueResizeReport(): void {
    if (resizeTimeoutId !== undefined) {
        clearTimeout(resizeTimeoutId)
    }

    resizeTimeoutId = setTimeout(() => {
        resizeTimeoutId = undefined
        const currentWidth = window.innerWidth
        if (currentWidth === lastWindowWidth) {
            return
        }

        lastWindowWidth = currentWidth
        reportResize()
    }, 200)
}

function handleWindowResize(): void {
    queueResizeReport()
}

window.addEventListener('click', reportClick)
window.addEventListener('resize', handleWindowResize)
window.addEventListener('load', () => {
    const stopWatching = watchBodyMutations(reportResize)
    reportResize()

    window.addEventListener('unload', stopWatching)
})
